import { fetchConfigurationIfNeeded } from '@lootboy/lib/actions/ConfigurationActions';
import useFetchSelector from '@lootboy/lib/hooks/useFetchSelector';

import { configurationPlainSelector } from '~/redux/selectors';

export default () =>
  useFetchSelector(fetchConfigurationIfNeeded, configurationPlainSelector)
    ?.data;
